var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useThemePart } from '../../theme/ThemeHelpers';
import IconContainer, { IconSVG } from './IconContainer';
var IconCheckboxChecked = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    var bg = useThemePart(function (t) { return t.colors.darkerGrey; });
    var fg = color !== null && color !== void 0 ? color : useThemePart(function (t) { return t.colors.mainBackground; });
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-2.167 -2.167)" },
                React.createElement("rect", { x: "5.3", y: "5.3", style: { fill: bg, stroke: bg }, width: "23.8", height: "23.8" })),
            React.createElement("path", { 
                // style={{stroke: fg, strokeWidth: 2}}  
                d: "M8.2,16.1l3.7,3.7l9.8-9.8", style: { stroke: fg, strokeWidth: 2 } }))));
});
export default IconCheckboxChecked;
//# sourceMappingURL=IconCheckboxChecked.js.map